// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/nominativi?ruolo=FORNITORE&limit=200&societaId=N',
    requestBody: null,
    response: '{"data":"Nominativo[]","total":0}'
  },
  {
    method: 'GET',
    endpoint: '/api/anagrafiche/listini?societaId=N&fornitoreId=N&page=1&limit=20',
    requestBody: null,
    response: '{"success":true,"data":"ImportListino[]","total":"number","page":"number","limit":"number"}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
